export default "__VITE_ASSET__e5fb8555__"